module.exports = __webpack_public_path__ + "img/Widget_card_headpics_EB_stuff.5bcf1937.jpg";